module.exports = __webpack_public_path__ + "img/icons-179.b1e8e6c7.svg";